(function () {
  var HOME = 'https://www.myst.ltd';
  try {
    if (window.Shopify && window.Shopify.designMode) return;
    if (window.location.search.indexOf('stay=1') !== -1) return;
    if (window.top && window.top !== window.self) { window.top.location.replace(HOME); return; }
  } catch (e) {}
  window.location.replace(HOME);
})();

class PasswordModal extends DetailsModal {
  constructor() {
    super();

    if (this.querySelector('input[aria-invalid="true"]')) this.open({ target: this.querySelector('details') });
  }
}

customElements.define('password-modal', PasswordModal);
